import type { CSSProperties, KeyboardEvent, ReactNode } from 'react';
import './list-row.css';

export interface ListRowProps {
  /** Leading element: usually an Avatar or RowChip. */
  lead?: ReactNode;
  title?: ReactNode;
  /** Second line of compact facts, already joined by the caller when needed. */
  meta?: ReactNode;
  /** Node beside the title, usually a Tag. */
  trailing?: ReactNode;
  /** Right-aligned action buttons. */
  actions?: ReactNode;
  onClick?: () => void;
  style?: CSSProperties;
}

/** Compact card-list equivalent of a table row. */
export function ListRow({ lead, title, meta, trailing, actions, onClick, style }: ListRowProps) {
  return (
    <div
      className="listRow"
      style={style}
      {...(onClick
        ? {
            role: 'button' as const,
            tabIndex: 0,
            onClick,
            onKeyDown: activateWithKeyboard(onClick),
          }
        : {})}
    >
      {lead ? <span className="listRowLead">{lead}</span> : null}
      <span className="listRowBody">
        <span className="listRowTitleLine">
          {title ? <span className="listRowTitle">{title}</span> : null}
          {trailing}
        </span>
        {meta ? <span className="listRowMeta">{meta}</span> : null}
      </span>
      {actions ? <span className="listRowActions">{actions}</span> : null}
    </div>
  );
}

function activateWithKeyboard(onClick: () => void) {
  return (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };
}
